"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmFieldTemplate = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
const caption_1 = require("./caption");
const SmFieldTemplate = (_a) => {
    var { id, label, labelIcon, message, invalid, state, sizeInput, disabled, type = 'text', srOnly, className } = _a, props = __rest(_a, ["id", "label", "labelIcon", "message", "invalid", "state", "sizeInput", "disabled", "type", "srOnly", "className"]);
    const containerClassname = (0, classnames_1.default)({
        '-invalid': invalid,
        '-disabled': disabled,
    }, 'c-field', `-${state}`, `-${sizeInput}`, className);
    const controlClassname = (0, classnames_1.default)('c-control', `-${type}`);
    return (react_1.default.createElement("div", { className: containerClassname },
        !srOnly && (react_1.default.createElement("label", { className: "c-field__label", htmlFor: id },
            label,
            labelIcon && (react_1.default.createElement(Icon_1.SmIcon, { name: labelIcon, type: "outlined", size: "small" })))),
        react_1.default.createElement("div", { className: controlClassname }, props.children),
        react_1.default.createElement(caption_1.SmCaption, { id: id, message: message, state: state })));
};
exports.SmFieldTemplate = SmFieldTemplate;
//# sourceMappingURL=field.js.map